import * as angular from 'angular';
import { CallAncillariesPageService } from '../../../../../../features/services/services/services/ib-call-ancillaries-service';
import { ExternalAncillariesService } from '../../../../../../features/services/services/services/ib-external-ancillaries-service';

export class IbBobFormService {
    constructor (
        private $q: ng.IQService,
        private ExternalAncillariesService: ExternalAncillariesService,
        private BobFormTransformer: any,
        private IBCGdprService: IBCGdprService,
        private CommonsAncillariesService: CommonsAncillariesService) {
    }

    /**
    * @function initBobModal
    *
    * Function that calls the ExternalAncillariesService to obtain the pick up slots
    *
    * @return {promise} {}
    */
    initBobModal = (segments: any): angular.IPromise<any> => {
        let defer = this.$q.defer(), addressInfo, promise, response = {};
        const pickUpPromises = [];
        for (let i = 0; i < segments.length; ++i) {
            addressInfo = {
                area: segments[i].departure.airportCode,
                limitDate: segments[i].departure.originalDate
            };
            promise = this.ExternalAncillariesService.getBobPickUpSlots(addressInfo);
            pickUpPromises.push(promise);
        }

        this.$q.all(pickUpPromises).then((data:any) => {
            this.IBCGdprService.getGdprInfo('DIGTRABOB').then((gdprData:any):any => {
                response = {
                    pickUpData: data,
                    text: gdprData.text
                };
                defer.resolve(response);
                defer = null;
            }, (error) => {
                response = {
                    pickUpData: data,
                    text: ''
                };
                defer.resolve(response);
                defer = null;
            });


        }, errorService);

        function errorService (error) {
            defer.reject(error);
            defer = null;
        }

        return defer.promise;
    };


    /**
     * @function validateBobAddress
     *
     * Function that calls the ExternalAncillariesService to validate de address for the BoB Order
     *
     * @return {promise} {}
     */
    validateBobAddress = (addressInfo): angular.IPromise<any> => {
        let defer = this.$q.defer();
        this.ExternalAncillariesService.validateBobAddress(addressInfo).then((data) => {
            defer.resolve(data);
            defer = null;
        }, errorService);

        function errorService (error) {
            defer.reject(error);
            defer = null;
        }

        return defer.promise;
    };



    /**
     * @function createBobOrder
     *
     * Function that calls the ExternalAncillariesService to create a new BoB Order
     *
     * @return {promise} {}
     */
    createBobOrder = (bobOrder): angular.IPromise<any> => {
        let defer = this.$q.defer();
        this.ExternalAncillariesService.createBobOrder(bobOrder).then((data) => {
            updateAncillaries(bobOrder, data, this);
        }, errorService);

        function errorService (error) {
            defer.reject(error);
            defer = null;
        }
        function updateAncillaries (bobOrder, bobResponse, ibFormService) {
            const deferred = ibFormService.$q.defer();
            const update = ibFormService.BobFormTransformer.generateUpdateBob(bobOrder, bobResponse);
            ibFormService.CommonsAncillariesService.updateAncillaries(update).then(updateAncillariesSuccess, updateAncillariesError);

            return deferred.promise;

            function updateAncillariesSuccess (data) {
                defer.resolve(bobResponse);
                defer = null;

                deferred.resolve(data);

            }

            function updateAncillariesError (error) {
                errorService(error);
                deferred.reject(error);
            }
        }
        return defer.promise;
    };

}

IbBobFormService.$inject = ['$q', 'ExternalAncillariesService', 'BobFormTransformer', 'IBCGdprService', 'CommonsAncillariesService'];
try {
    const mod = angular.module('ib-bob-form-module');
    mod.service(
        'IbBobFormService',
        IbBobFormService
    );
} catch (error) {
    const mod = angular.module('ib-bob-form-module', []);
    mod.service(
        'IbBobFormService',
        IbBobFormService
    );
}